import { ActionType, IAutoReleasePayload } from "models/contract/autoRelease";
import { IResponse } from "models";

export const autoReleaseAction = (payload: IAutoReleasePayload) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_AUTO_RELEASE,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_AUTO_RELEASE_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_AUTO_RELEASE_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.CONTRACT_INFORMATION_AUTO_RELEASE_RESET,
  };
};
